(function () {
    angular.module('components.accordionColumns')
        .component('accordionColumnsContent', {
            require: {
                accordionColumns: '^accordionColumns'
            },
            transclude: {
                'default': 'default',
                'content': 'content'
            },
            template: '<div class="default-content" ng-hide="!!$ctrl.currentLink"></div><div class="content" ng-hide="!$ctrl.currentLink"><div ng-bind-html="$ctrl.content"></div></div>',
            controller: accordionColumnsContentController
        });

    accordionColumnsContentController.$inject = ['$scope', '$element', '$transclude'];
    function accordionColumnsContentController($scope, $element, $transclude) {
        var ctrl = this;

        ctrl.$onInit = function () {
            $element.addClass('grid-content');
            ctrl.accordionColumns.registerContent(ctrl);
        }

        ctrl.$postLink = function () {
            $transclude($scope, function (clone) {
                if (clone.length)
                    $element.find('.default-content').html(clone);
            }, null, "default");
            $transclude($scope, function (clone) {
                if (clone.length)
                    $element.find('.content').html(clone);
            }, null, "content");
        }

        ctrl.updateContent = function (link) {
            ctrl.currentLink = link;
        }

        ctrl.backToDefault = function () {
            ctrl.currentLink = null;
        }
    }
})();